import React,{createContext,useReducer} from 'react'
import PropTypes from 'prop-types'
import {withRouter} from 'react-router-dom'

import {
  RenderWebHostingButtonConnector,
  RenderWebHostingBillingCycleConnector,
  RenderWebHostingPriceConnector,
} from './webhosting'


import {
  RenderCustomHostingResourcesConnector
} from './customhosting'

import {
  RenderSearchDomainNameConnector,
} from './domainname'

import {
  RenderPayInvoiceConnector
} from './payinvoice'

import {
  RenderQuickSearchDomain
} from './domainname/quickbulksearch'

import {
  RenderFullSearchDomain
} from './domainname/fullbulksearch'

import {RenderSSLSelectorConnector} from './ssl'

import {RenderViewcartConnector} from './viewcart'
import ConnectorFunctions from './functions'
import RenderSelectHostingConnector from "./selecthosting";

export const MONTHLY = 'Monthly'
export const ANNUALLY = 'Annually'
export const QUARTERLY = 'Quarterly'
export const SEMI_ANNUALLY = 'Semi-Annually'
export const BIENNIALLY = 'Biennially'
export const Triennially = 'Triennially'




export const ConnectorContext = createContext()


export const UPDATE_BILLING_CYCLE = 'update-billing-cycle'
export const UPDATE_CONFIG_OPTIONS = 'update-cofig-options'
export const UPDATE_ADDONS = 'update-addons'

const ConnectorInitialState = {
  webHosting: {
    billingCycle: MONTHLY
  },
  customHosting: {
    billingCycle: MONTHLY
  }
};
const ConnectorReducer = (state, action) => {

  const  getCycleUpdated = () => {
    let updated = Object.assign({},state)
    if(updated[action.productType] && updated[action.productType]['billingCycle'] && action.cycle){
      updated[action.productType]['billingCycle']  = action.cycle
    }
    return updated
  }

  const  getConfigUpdated = () => {
    let updated = Object.assign({},state)
    if(updated[action.productType] && action.configOptions){
      updated[action.productType]['configOptions']  = action.configOptions
      updated[action.productType]['preset']  = action.preset
    }
    return updated
  }

  const  getADDONSUpdated = () => {
    let updated = Object.assign({},state)
    if(updated[action.productType] && action.addons){
      updated[action.productType]['addons']  = action.addons
    }
    return updated
  }


  switch (action.type) {
    case UPDATE_BILLING_CYCLE:
      return({
        ...state,
        ...getCycleUpdated()
      })
    case UPDATE_CONFIG_OPTIONS:
      return({
        ...state,
        ...getConfigUpdated()
      })
    case UPDATE_ADDONS:
      return({
        ...state,
        ...getADDONSUpdated()
      })
    default:
      return state
  }
};
const ConnectorProvider = (props) =>{
  const {children,reducer,initialState} = props
  const [state,dispatch] = useReducer(reducer,initialState)
  return (
    <ConnectorContext.Provider value={{state, dispatch}}>{children}</ConnectorContext.Provider>
  )
}
ConnectorProvider.propTypes = {
  children : PropTypes.any,
  reducer: PropTypes.any,
  initialState: PropTypes.any
}





let SiteConnector = (props) => {
  const {history,location} = props
  const router = {
    history,
    location
  }
  return (<ConnectorProvider reducer={ConnectorReducer} initialState={ConnectorInitialState}>
      <RenderWebHostingButtonConnector router={router}/>
      <RenderWebHostingBillingCycleConnector router={router}/>
      <RenderWebHostingPriceConnector />
      <RenderCustomHostingResourcesConnector router={router}/>
      <RenderSearchDomainNameConnector router={router} />
      <RenderPayInvoiceConnector router={router} />
      <RenderQuickSearchDomain router={router} />
      <RenderFullSearchDomain router={router} />
      <RenderViewcartConnector router={router} />
      <RenderSSLSelectorConnector router={router} />
      <RenderSelectHostingConnector router={router}/>
      <ConnectorFunctions router={router}/>
  </ConnectorProvider>)
}

SiteConnector.propTypes = {
  history : PropTypes.any,
  location : PropTypes.any
}

SiteConnector = withRouter(SiteConnector)


export default SiteConnector
